



























import Vue from 'vue'
import XCheckbox from '@/components/atoms/Checkbox/XCheckbox.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import {
  CreatePartnerApplicationInput,
  ServicePlan,
} from '@/types/generated/graphql'

type Props = {
  value: CreatePartnerApplicationInput & { storeCount: number }
  servicePlans?: ServicePlan[]
}

type Methods = {
  validate: (useAffiliate: boolean, servicePlanIds: string[]) => void
}

type Computed = {
  servicePlanIds: string[]
  useAffiliate: boolean
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: 'SelectPlan',
  components: { XFormLabel, XCheckbox },
  props: {
    value: {
      type: Object,
    },
    servicePlans: {
      type: Array,
    },
  },
  computed: {
    servicePlanIds: {
      get() {
        return this.value.servicePlanIds || []
      },
      set(servicePlanIds) {
        this.validate(this.useAffiliate, servicePlanIds)
        this.value.servicePlanIds = servicePlanIds
      },
    },
    useAffiliate: {
      get() {
        return this.value.useAffiliate
      },
      set(useAffiliate) {
        this.validate(useAffiliate, this.servicePlanIds)
        this.value.useAffiliate = useAffiliate
      },
    },
  },
  methods: {
    async validate(useAffiliate: boolean, servicePlanIds: string[]) {
      const provider = this.$refs.provider as any
      // 少なくとも一つのサービスプランが必要
      await provider.validate(useAffiliate || servicePlanIds.length || '')
    },
  },
})
